<template>
  <div class="signOuter">
    <div class="sign_container">
      <div class="title">
        <img :src="activityModel.coverUrl" alt="coverUrl">
        <div class="content">
          <p>{{activityModel.activityName}}</p>
          <p>{{(activityModel.city ? activityModel.city : '') + (activityModel.address ? ((activityModel.city ? '-' :
            '') + activityModel.address) : '')}}</p>
        </div>
      </div>
      <div class="channel_form">
        <p class="register_title">Feel free to fill out in your native language.</p>
        <el-form :model="applyFormModel" :rules="rules" ref="signFormRef" label-width="100%" class="sign_form">
          <el-form-item class="select_form_item" label="Attendance Time" prop="activityTimeId" v-if="options.length>1" :rules="options.length>1?rules.activityTimeId:[]">
            <el-select v-model="applyFormModel.activityTimeId" placeholder="请选择">
              <el-option
                v-for="item in options"
                :key="item.activityTimeId"
                :label="item.sectionStartDate+'--'+item.sectionEndDate"
                :value="item.activityTimeId">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="Full Name（as Per IC/ Passport）" prop="contactName">
            <el-input style="magin:0;" v-model="applyFormModel.contactName" max="100"></el-input>
          </el-form-item>
          <el-form-item class="international-mobile" label="Phone  number" prop="contactMobile" required>
            <div
              class="international-mobile-text"
              @click="internationalMobileShow = true">
              <span>+{{ applyFormModel.contactMobileAreaCode }}</span>
              <img
                class="international-mobil-img"
                src="../../static/img/to-b-icon.png"
              />
            </div>
            <el-input :maxlength="applyFormModel.contactMobileAreaCode == '86'?'11':'15'"
                      v-model="applyFormModel.contactMobile" @change="handleMobileChange"></el-input>
          </el-form-item>
          <el-form-item label="Company Name" prop="companyName" v-if="showType">
            <el-input v-model="applyFormModel.companyName"></el-input>
          </el-form-item>
          <el-form-item label="Position" prop="position" v-if="showType">
            <el-input v-model="applyFormModel.position"></el-input>
          </el-form-item>
          <el-form-item label="Number of Employees" prop="staffSize" v-if="showType">
            <el-input v-model="applyFormModel.staffSize"></el-input>
          </el-form-item>
          <el-form-item label="Email" prop="email">
            <el-input v-model="applyFormModel.email"></el-input>
          </el-form-item>
          <el-form-item label="Company Industry" v-if="showType">
            <el-input v-model="applyFormModel.industry"></el-input>
          </el-form-item>
          <el-form-item label="Company‘s Annual Revenue" v-if="showType">
            <el-input v-model="applyFormModel.annualProfit"></el-input>
          </el-form-item>
          <el-form-item label="WhatsApp/Zalo" prop="weixin">
            <el-input v-model="applyFormModel.weixin"></el-input>
          </el-form-item>
        </el-form>
        <div class="footer">
          <button @click="submitForm('signFormRef')"> Click to Register</button>
        </div>
      </div>
    </div>
    <mt-popup
      v-model="internationalMobileShow"
      position="right"
      style="height: 100%; width: 100%"
    >
      <div class="international-heade">
        <div class="international-title">
          <img
            @click="internationalMobileShow = false"
            src="../../static/img/go-left.png"
          />
          <div>Select country or region</div>
        </div>
        <div class="international-input">
          <el-input
            class="international-input-border"
            label=""
            placeholder="Query Country/Area"
            v-model="queryStr"
          >
            <el-button slot="append" icon="el-icon-search" @click="getCountryInfoPhoneList">search for</el-button>
          </el-input>
        </div>
      </div>

      <div class="login-index-list">
        <mt-index-list>
          <mt-index-section
            v-for="(item, index1) in countryInfoPhoneList"
            :key="index1"
            :index="item.firstEn">
            <mt-cell
              v-for="(i, index2) in item.infoModelList"
              :key="index2"
              :title="i.nameCn+'+'+i.countryCode "
              @click.native="infoModelData(i.countryCode)">1
            </mt-cell>
          </mt-index-section>
        </mt-index-list>
      </div>
    </mt-popup>
  </div>
</template>

<script>
  import Common from "@/utils/common";
  import customerService from '@/api/customerService'
  import $ from 'jquery'
  import '../../static/jquery-cookie/jquery.cookie.js'
  import md5 from 'js-md5';

  export default {
    name: "sign_register",
    data() {
      const validatePass = (rule, value, callback) => {
        if (value === '') {
          callback(new Error('Enter Phone number'));
        }
        if (Common.Util.isMobileCode(this.applyFormModel.contactMobileAreaCode, value)) {
          callback();
        } else {
          callback(new Error('Wrong Phone number'));
        }
        callback();
      };
      return {
        activityModel: {},
        verifyText: 'obtain code',
        btnLocked: false,
        network: true,//默认有网
        timeStamp: '',
        internationalMobileShow: false,
        countryInfoPhoneList: [],
        queryStr: '',
        codeValueList: [],
        applyFormModel: {
          activityTimeId: '',
          contactName: '',
          contactMobile: '',
          verifyCode: '',
          companyName: '',
          position: '',
          industry: '',
          staffSize: '',
          annualProfit: '',
          weixin: '',
          contactMobileAreaCode: '86',
          email: '',
        },
        rules: {
          activityTimeId: [
            {required: true, message: 'Please select', trigger: 'change'}
          ],
          contactName: [
            {required: true, message: 'Enter name', trigger: 'blur'},
            {min: 1, max: 100, message: '100 words maximum', trigger: 'blur'}
          ],
          contactMobile: [
            {validator: validatePass, trigger: 'blur'}
          ],
          verifyCode: [
            {required: true, message: 'Enter code', trigger: 'blur'},
            {min: 1, max: 20, message: '10 words maximum', trigger: 'blur'}
          ],
          companyName: [
            {required: true, message: 'Enter Company Name', trigger: 'blur'},
            {min: 1, max: 100, message: '100 words maximum', trigger: 'blur'}
          ],
          position: [
            {required: true, message: 'Enter Position', trigger: 'blur'},
            {min: 1, max: 100, message: '100 words maximum', trigger: 'blur'}
          ],
          industry: [
            {required: true, message: 'Enter Company Industry', trigger: 'blur'},
            {min: 1, max: 100, message: '100 words maximum', trigger: 'blur'}
          ],
          staffSize: [
            {required: true, message: 'Enter Number of Employees', trigger: 'blur'},
            {min: 1, max: 100, message: '100 words maximum', trigger: 'blur'}
          ],
          annualProfit: [
            {required: true, message: 'Enter Company‘s Annual Revenue', trigger: 'blur'},
            {min: 1, max: 100, message: '100 words maximum', trigger: 'blur'}
          ],
          email: [
            {required: true, message: 'Enter Email', trigger: 'blur'},
            {min: 1, max: 100, message: '100 words maximum', trigger: 'blur'}
          ],
          weixin: [
            {max: 100, message: '100 words maximum', trigger: 'blur'}
          ]
        },
        prodActivityIds: ["dec09095206b48bbbfc5125e4fc1d66b", "c535ac8517ec446d9fbe7b1504aeed42", "e90025ce1fa64c318566596c21339ac6",
          "08c2d26c69164be19bff9a1d320bdb43", "ac4e6d5d49e9434ab051b65fa6899dd0",
          "a89319f0b8004fb594cb13484d6eca02",
          "357533f8aa8c4cfb8ef8824e3f2e9c40",
          "bd37ab7f7a014a5cb9c022c4849248f5",
          "b6e18fdb7c314e548612298825b8fb0f",
          "ba4f45687e96478ba7e7514c3a994d1f",
          "e97cf6d102f74ce5bb5f0a399e1fdce0",
        ],

        testActivityIds: [
          "481ac0606dab4d4db2b9863c7c8c6300",
          "08f6204c87644b3096b6f03ec5f7d201",
          "985be476980f4baf8343fc46529fe2ea",
          "2df888d25d2a45cd8a59c3f5af185bc4",
          "68f0bee2925743caaa64f65116f28dcc",
        ],
        showType: true,
        codeValueShow: true,
        tt_test_id: '',
        options:[],
      }
    },
    mounted() {
      var vm = this;
      document.title = 'Registration Form';
      var url = window.location.href;
      //广告Id
      if (vm.$route.query.tt_test_id) {
        vm.tt_test_id = vm.$route.query.tt_test_id;
        $.cookie('tt_test_id', vm.tt_test_id)
      } else {
        vm.tt_test_id = $.cookie('tt_test_id');
        $.cookie('tt_test_id', '')
      }
      vm.activityModel = {
        activityId: vm.$route.query.activityId,
        channelId: vm.$route.query.channelId,
        sponsor: vm.$route.query.sponsor,
        activityName: vm.$route.query.activityName,
        coverUrl: vm.$route.query.coverUrl,
        city: vm.$route.query.city,
        address: vm.$route.query.address,
        type: vm.$route.query.type
      };
      if (vm.$route.query.activityTimeList) {
        vm.options = JSON.parse(decodeURIComponent(vm.$route.query.activityTimeList));
        vm.applyFormModel.activityTimeId = vm.options[0].activityTimeId;
      }
      if (url.includes('//erp.bosum.com/customerActivity/')) {
        if (vm.prodActivityIds.includes(vm.activityModel.activityId)) {
          vm.showType = false;
          vm.applyFormModel.companyName = "公司未知";
          vm.applyFormModel.position = "职位未知";
        }
      } else {
        if (vm.testActivityIds.includes(vm.activityModel.activityId)) {
          vm.showType = false;
          vm.applyFormModel.companyName = "公司未知";
          vm.applyFormModel.position = "职位未知";
        }
      }
      if (vm.$route.query.activityType != '公开课') {
        vm.showType = false;
        vm.applyFormModel.companyName = "公司未知";
        vm.applyFormModel.position = "职位未知";
      }
      window.addEventListener('offline', () => {
        this.network = false
      });
      window.addEventListener('online', () => {
        this.network = true
      });
      vm.getCountryInfoPhoneList()
      vm.getByCodeValueModel()
      vm.getZone()
      vm.googleAnalytics()
    },
    methods: {
      //提交表单（广告统计）
      submitFormAd() {
        var vm = this;
        ttq.track('SubmitForm', {
          contents: [
            {
              content_id: vm.activityModel.channelId,
              content_name: vm.activityModel.activityName,
              email: vm.applyFormModel.email,
              phone_number: vm.applyFormModel.contactMobile,
            }
          ]
        })
      },
      //提交完成（广告统计）
      completeRegistration() {
        var vm = this;
        ttq.track('CompleteRegistration', {
          contents: [
            {
              content_id: vm.activityModel.channelId,
              content_name: vm.activityModel.activityName,
            }
          ]
        })
      },
      getCountryInfoPhoneList() {
        var vm = this
        customerService.getCountryInfoPhoneList(this).then(function (data) {
          for (var i = 0; i < data.length; i++) {
            if (data[i].firstEn === 'hot') {
              var obj = data.splice(i, 1);
              obj[0].firstEn = '热门'
              break;
            }
          }
          data.unshift(obj[0]);
          vm.countryInfoPhoneList = data;
          vm.getZone()
        });
      },
      getByCodeValueModel() {
        var vm = this
        var code = "CANCELLATION_SOUTHEAST_ASIA_CODE"
        customerService.getByCodeValueModel(vm, code).then(function (data) {
          data.forEach(i => {
            vm.codeValueList.push(i.codeValue)
          });
          if (vm.codeValueList.includes(vm.activityModel.activityId)) {
            vm.codeValueShow = false;
          }

        });
      },
      infoModelData(val) {
        this.applyFormModel.contactMobileAreaCode = val
        this.internationalMobileShow = false
      },
      handleMobileChange() {
        var vm = this;
        if (Common.Util.isEmpty(vm.applyFormModel.contactMobile)) {
          return;
        }
        if (!/^\d+$/.test(vm.applyFormModel.contactMobile)) {
          Common.PageOperator.showPromptMsg(vm, true, 'Mobile number format error', 'warning');
          vm.applyFormModel.contactMobile = '';
        }
      },
      handleVerifyCode() {
        var vm = this;
        if (Common.Util.isEmpty(vm.applyFormModel.verifyCode)) {
          return;
        }
        if (!/^\d+$/.test(vm.applyFormModel.verifyCode)) {
          Common.PageOperator.showPromptMsg(vm, true, 'Verification code format error', 'warning');
          vm.applyFormModel.verifyCode = '';
        }
      },
      //发送短信验证码
      sendVerifyCode: function () {
        var vm = this;
        if (!vm.network) {
          Common.PageOperator.showPromptMsg(vm, true, ' Network Error, Please try again later！', 'warning');
          return;
        }
        vm.btnLocked = true;//发送按钮上锁
        var sign = vm.encryption(vm.applyFormModel.contactMobile);
        customerService.sendChannelValidate(vm, vm.applyFormModel.contactMobile, sign, vm.timeStamp, vm.applyFormModel.contactMobileAreaCode).then(function (data) {
          vm.verifyText = 60;
          var timer = setInterval(function () {
            if (vm.verifyText <= 1) {
              vm.verifyText = 'Resend';
              vm.btnLocked = false;
              clearInterval(timer);
            } else {
              vm.verifyText--;
            }
          }, 1000);
        }, function (error) {
          vm.verifyText = 'Resend';
          vm.btnLocked = false;
        });
      },
      encryption: function (mobile) {
        var vm = this;
        var appid = 'sysBosumVerification';
        var appSecret = 'f94fdab1a50f4a45a6332e08311f96ff';
        var normalUrl = '/phone/activity/verifyCode';
        //时间戳
        vm.timeStamp = new Date().getTime();
        //参数排序
        var params = {
          "appid": appid,
          "mobile": mobile,
          "method": normalUrl,
          "timestamp": vm.timeStamp
        };
        return vm.getSign(params, appSecret);
      },
      getSign: function (params, appSecret) {
        var paramList = [];
        for (var pos in params) {
          paramList.push(pos);
        }
        var paramArr = paramList.sort();
        for (var i = 0; i < paramArr.length; i++) {
          var paramValue = params[paramArr[i]];
          paramArr[i] = paramArr[i] + paramValue;
        }
        var paramStr = paramArr.join('');
        var resultStr = appSecret + paramStr + appSecret;
        //MD5 加密
        resultStr = md5(resultStr);
        return resultStr;
      },
      submitForm(formName) {
        var vm = this;
        if (!vm.network) {
          Common.PageOperator.showPromptMsg(vm, true, 'Network Error, Please try again later！', 'warning');
          return;
        }
        vm.$refs[formName].validate((valid) => {
          if (valid) {
            var applyFormModel = Common.Util.clone(vm.applyFormModel);
            delete applyFormModel.verifyCode;
            if (vm.activityModel.channelId) {
              applyFormModel.channelId = vm.activityModel.channelId
              applyFormModel.sponsor = vm.activityModel.sponsor
            }
            console.log(applyFormModel.contactMobile)
            if (vm.tt_test_id) {
              vm.submitFormAd();
            }
            customerService.activityShareSignUp(vm, vm.activityModel.activityId, vm.applyFormModel.verifyCode, vm.activityModel.type, applyFormModel).then(function (data) {
              //判断data
              var activitySignId = '';
              if (Common.Util.isObject(data)) {
                if (data && data.activitySignId && data.isSigned) {
                  activitySignId = data.activitySignId;
                  Common.PageOperator.showPromptMsg(vm, true, ' You have already registered. No need to register again！', 'warning');

                  var query = {
                    activityId: vm.activityModel.activityId,
                    channelId: vm.activityModel.channelId,
                    type: vm.activityModel.type,
                    activitySignId: activitySignId
                  }
                  if (vm.tt_test_id) {
                    vm.completeRegistration();
                    query.tt_test_id = vm.tt_test_id;
                  }
                  vm.$router.push({
                    path: '/signResult',
                    query: query
                  });
                }
              } else {
                activitySignId = data;
                Common.PageOperator.showPromptMsg(vm, true, 'Please make the payment to complete your registration！', 'warning');
                if (vm.tt_test_id) {
                  vm.completeRegistration();
                }
                if (!Common.Util.isEmpty(activitySignId)) {
                  vm.goToSignResultPage(activitySignId);
                }
              }
            });
          } else {
            return false;
          }
        });
      },
      // 直接跳转支付
      payFun: function (activitySignId) {
        //console.log('--直接跳转支付--',activitySignId)
        var vm = this;
        customerService.stripePay(vm, activitySignId, vm.activityModel.channelId).then(function (data) {
          window.location.href = data;
        });
      },
      goToSignResultPage(activitySignId) {
        var url = window.location.href;
        var vm = this;
        $.cookie(vm.activityModel.activityId, activitySignId);
        //渠道id报名也存储,方便二次进来获取
        $.cookie(vm.activityModel.channelId + '_channelId', activitySignId)
        if (url.includes('//erp.bosum.com/customerActivity/')) {
          // 正式
          if (vm.prodActivityIds.includes(vm.activityModel.activityId)) {
            vm.payFun(activitySignId)
            return
          }
        } else {
          // 测试
          if (vm.testActivityIds.includes(vm.activityModel.activityId)) {
            vm.payFun(activitySignId)
            return
          }
        }
        var query = {
          activityId: vm.activityModel.activityId,
          channelId: vm.activityModel.channelId,
          type: vm.activityModel.type,
          activitySignId: activitySignId
        }
        if (vm.tt_test_id) {
          query.tt_test_id = vm.tt_test_id;
        }
        vm.$router.push({
          path: '/signResult',
          query: query
        });
      },
      // 获取地区
      getZone() {
        var vm = this
        fetch("https://ipinfo.io?token=90739443e1c192").then((response) => response.json())
          .then((data) => {
            const country = data.country;
            if (country) {
              vm.countryInfoPhoneList.forEach((item) => {
                item.infoModelList.forEach((item2) => {
                  if (country == item2.code) {
                    vm.applyFormModel.contactMobileAreaCode = item2.countryCode
                  }
                })
              })
            }
          })
          .catch((error) => {
            console.error("获取国家/地区信息时出错：", error);
          });
      },
      // 谷歌广告统计
      googleAnalytics() {
        if (this.$route.query.activityId == 'a6873c4a9463431996622e4d34b09cce') { // a6873c4a9463431996622e4d34b09cce,9e9314de03554b6a87e8102120169b93
          const script = document.createElement('script');
          script.innerHTML = `(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
              new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
              j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
              'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
              })(window,document,'script','dataLayer','GTM-TJC9C2VV');`
          document.head.appendChild(script);
          const noscript = document.createElement('noscript');
          const iframe = document.createElement('iframe');
          iframe.src = "https://www.googletagmanager.com/ns.html?id=GTM-TJC9C2VV"
          iframe.style.height = 0;
          iframe.style.width = 0;
          iframe.style.display = 'none';
          iframe.style.visibility = 'hidden';
          noscript.appendChild(iframe);
          document.body.appendChild(noscript);
        }
      }
    }
  }
</script>
<style scoped>
  .signOuter {
    background: #f6f6f6;
    width: 100vw;
    height: 100vh;
    overflow-y: auto;
    overflow-x: hidden;
  }

  .sign_container {
    max-width: 500px;
    margin: 0 auto;
    background: #fff;
  }

  .sign_form {
    padding-top: 10px;
  }

  .title {
    display: flex;
    padding: 20px;
  }

  .title > img {
    width: 80px;
    height: 60px;
    margin-right: 10px;
    border-radius: 3px;
  }

  .title > div > p:first-child {
    margin-bottom: 10px;
  }

  .content {

  }

  .register_title {
    background: #f0f0f0;
    height: 40px;
    line-height: 40px;
    color: #000;
    padding-left: 10px;
  }

  .footer {
    padding: 20px 10px 100px 10px;
  }

  .footer > button {
    width: 100%;
    height: 44px;
    background-image: linear-gradient(#d43d3d, #d43d3d);
    border: 1px solid rgba(254, 43, 84, .2);
    text-align: center;
    color: #fff;
    font-size: 16px;
    border-radius: 3px;
  }

  .verify_btn {
    border: 1px solid #d43d3d;
    background: #fff;
    color: #d43d3d;
    width: 100px;
    height: 32px;
    border-radius: 16px;
  }

  /deep/ .international-mobile > .el-form-item__content {
    display: flex;
    justify-content: space-between;
  }

  .mint-indexsection-index {
    font-weight: 800;
  }

  .stem-weight {
    font-weight: 800;
  }

  .international-mobile-text {
    color: #666;
    font-size: 15px;
    width: 80px;
    margin-left: 10px;
  }

  .international-mobil-img {
    width: 11px;
    height: 7px;
  }

  .international-heade {
    padding: 10px 15px;
    position: fixed;
    width: 100%;
    height: 110px;
  }

  .international-title {
    display: flex;
    align-items: center;
    justify-content: center;
    position: relative;
    font-size: 18px;
    font-weight: 800;
  }

  .international-title > img {
    width: 23px;
    position: absolute;
    left: 0;
  }

  .international-input-border {
    margin-right: 20px;
    margin-top: 10px;
    border-radius: 10px;
  }

  .login-index-list {
    margin-top: 110px;
    margin-left: 15px;
  }

  .channel_form .el-form-item {
    display: flex;
    flex-direction: column;
    border: none;
  }

  /deep/ .el-form-item > .el-form-item__content {
    margin-left: 0 !important;
    border: 1px solid #DCDCDC;
    margin: 0 15px;
    border-radius: 4px;
    padding: 0;
  }

</style>



// WEBPACK FOOTER //
// src/views/sign_register.vue